import { commonTypes } from './types';

const setSidebar = (payload: boolean) => ({
  type: commonTypes.SET_SIDEBAR,
  payload,
});

const setCollapseSidebar = (payload: boolean) => ({
  type: commonTypes.SET_COLLAPSE_SIDEBAR,
  payload,
});

const setShowSecondBurger = (payload: boolean) => ({
  type: commonTypes.SET_SHOW_SECOND_BURGER,
  payload,
});

const commonActions = { setSidebar, setCollapseSidebar, setShowSecondBurger };

export default commonActions;
